import { isComplimentaryCrossSell } from '~/utils/crossSells'
import { formatPrice } from '~/utils/graphqlDataFormatters'

import { ReservableCrossSell } from '~/components/Restaurant/ReservableCrossSellItem/ReservableCrossSellItem'
import { ReservableMenuWithCrossSells } from '~/components/Restaurant/ReservableMenuWithCrossSells/ReservableMenuWithCrossSells'
import { ReservableTabHeader } from '~/components/Restaurant/ReservableTabHeader/ReservableTabHeader'
import { Festival, FestivalEditionRestaurant } from '~/generated/graphql'
import { gt } from '~/locale'
import { DangerousTranslate } from '~/shared/atoms/DangerousTranslate'
import { SingleMenu } from '~/shared/molecules/Menu/MenuView'

import { Wrapper } from './FerMenuTabShards'

type FERMenuTabProps = {
  fer: Pick<FestivalEditionRestaurant, 'price'> & {
    menus?: Array<SingleMenu> | null
    crossSells: Array<ReservableCrossSell>
    festivalEdition: {
      festival: Pick<Festival, 'name'>
      menuPositions: unknown[]
    }
  }
  onReserveClick: () => void
}

export const FERMenuTab = ({ fer, onReserveClick }: FERMenuTabProps) => {
  const festivalEdition = fer.festivalEdition
  const courseCount = festivalEdition.menuPositions.length

  return (
    <Wrapper>
      <ReservableTabHeader
        title={gt.tp('RestaurantPage', '{{ festivalName }} Menu', { festivalName: festivalEdition.festival.name })}
        subtitle={
          <DangerousTranslate
            text={gt.tnp(
              'RestaurantPage',
              'Special offer! Only {{ price }} for {{ courseCount }} course and a cocktail',
              'Special offer! Only {{ price }} for {{ courseCount }} courses and a cocktail',
              courseCount,
              {
                courseCount: courseCount,
                price: `<b>${formatPrice(fer.price)}</b>`,
              }
            )}
          />
        }
      />
      <ReservableMenuWithCrossSells
        menus={fer.menus || []}
        crossSells={fer.crossSells.filter(isComplimentaryCrossSell)}
        onReserveClick={onReserveClick}
      />
    </Wrapper>
  )
}

export default FERMenuTab
